module.exports = __webpack_public_path__ + "static/media/banner.49b3bccf.png";